import * as React from 'react';
import { ControlIcons } from 'owa-control-icons';
import { getPalette } from 'owa-theme';
import { IconButton } from '@fluentui/react/lib/Button';
import { isToday } from 'owa-observable-datetime';
import { observer } from 'mobx-react-lite';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import loc, { format } from 'owa-localize';
import { formatWeekDayMonthDayYear } from 'owa-datetime';
import { weekViewOverFlowExpandAllDay } from './CalendarOverflowIndicator.locstring.json';

const styles = require('./CalendarOverflowIndicator.scss');

export default observer(function CalendarOverflowIndicator({ item }: { item: CalendarEvent }) {
    const themeSymbols = getPalette();
    const color = isToday(item.Start) ? themeSymbols.themeDarkAlt : themeSymbols.themePrimary;

    const itemContentWrapperStyle: React.CSSProperties = {
        color,
        cursor: 'pointer',
        height: '100%',
    };

    const label = format(loc(weekViewOverFlowExpandAllDay), formatWeekDayMonthDayYear(item.Start));

    return (
        <IconButton
            className={styles.overflowIndicatorSubject}
            style={itemContentWrapperStyle}
            iconProps={{ iconName: ControlIcons.More }}
            title={label}
            ariaLabel={label}
        />
    );
});
